import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36b70d16"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Carica nuovo documento associato", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Documentazione", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_UploadForm = _resolveComponent("UploadForm")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, null, {
    h1: _withCtx(() => [
      _hoisted_1
    ]),
    h3: _withCtx(() => [
      _hoisted_2
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_PrimaryButton, {
        class: "button bg-white text-primary-900 undo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Annulla")
        ]),
        _: 1
      }),
      _createVNode(_component_PrimaryButton, {
        class: "button bg-primary-900 text-white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.create()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Carica documento")
        ]),
        _: 1
      }),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            message: "Salvataggio..."
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_UploadForm)
    ]),
    _: 1
  }))
}